function handleize(str) {
  return str
    .toLowerCase()
    .replace("'", '')
    .replace(/[^\w\u00C0-\u024f]+/g, '-')
    .replace(/^-+|-+$/g, '')
    .normalize('NFD')
    .replace(/[\u0300-\u036f]/g, '');
}

module.exports = {
  handleize,
};
